import Glide from '@glidejs/glide';
import {isMobile} from "@/utils/features";

export default function (dom, opts) {
    let options = {
        sliderOverlaySel: '.image-overlay',
        openOverlay: '[data-open-overlay]',
        closeOverlay: '[data-close-overlay]',
        showOverlayCls: 'image-overlay-open',
        ...opts
    };

    let glideOptions = {
        type: 'carousel',
        perView: 1,
        gap: 0,
        keyboard: false,
        autoplay: false,
        swipeThreshold: 80,
        dragThreshold: 120,
        perTouch: 1,
        touchRatio: 0.5,
        touchAngle: 45,
        rewind: true,
    };


    const sliderOverlay = dom.querySelector(options.sliderOverlaySel);
    const slideCountOverlay = [].slice.call(sliderOverlay.querySelectorAll('.glide__slide'), ).length;
    const overlayOpen = [].slice.call(dom.querySelectorAll(options.openOverlay), 0);
    const overlayClose = [].slice.call(dom.querySelectorAll(options.closeOverlay), 0);

    const html = document.documentElement;
    const body = document.body;

    if (slideCountOverlay) {
        const glideOverlay = new Glide(sliderOverlay.querySelector('.glide'), glideOptions).mount();
        overlayOpen.forEach((item, index) => {
            item.addEventListener('click', () => {
                glideOverlay.go(`=${index}`);
                html.classList.add(options.showOverlayCls);
            })
        });

        overlayClose.forEach(item => {
            item.addEventListener('click', () => {
                html.classList.remove(options.showOverlayCls);
            })
        });

        body.addEventListener('click', onOuterClick);

    }

    function onOuterClick(e) {
        if (!isMobile() && !dom.contains(e.target)) {
            html.classList.remove(options.showOverlayCls);
        }
    }
}
